"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "easing",
        type: "variable",
        value: `cubic-bezier(${token.x1}, ${token.y1}, ${token.x2}, ${token.y2})`,
    },
];
exports.default = transformToken;
